// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyFloorPlanDeleteV2RequestDto } from '../..';

export const RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/floorPlans/delete';

/**
 * Delete floor plan of a property
 */
export const RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete = (
  postData: UserPropertyFloorPlanDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyFloorPlanDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyFloorPlanDeleteV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
